// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__sAZkP","categoriesContainer":"Loader_categoriesContainer__fXpEu","loader":"Loader_loader__qZOCR"};